import styled from 'styled-components';

export const TestCycleTcListTabItemMenuOptionStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const MenuOptionIconStyled = styled.span`
  display: inline-block;
  margin-right: 4px;
`;

export const MenuOptionLabelStyled = styled.span`
  display: inline-block;
`;

export const ExecuteButtonStyled = styled.div`
  margin-right: 8px;
`;
